import { render, staticRenderFns } from "./ProfessionTaskCityPage.vue?vue&type=template&id=331d42c2"
import script from "./ProfessionTaskCityPage.vue?vue&type=script&lang=js"
export * from "./ProfessionTaskCityPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports